import accessible from "common/managers/accessible";

export default {

    initAccessibleMode: function() {
        if (this.element.is("select") && this.options.accessibleMode) {
            this.wrapper.addClass("isSelect");
            this.element.show();
            this.bind("dataBound", this._syncToElement);
            this.bind("change", this._syncToElement);
            this._syncToElement();
            this.element.on("change", $.proxy(this._syncToWidget, this));
        }
    },

    value: function() {
        var res = kendo.ui.MultiSelect.fn.value.apply(this, arguments);
        if(arguments.length > 0) {
            this._syncToElement();
        }
        return res;
    },

    _syncToElement: function() {
        if (!this._syncing) {
            this.element.val(this.value());
        }
    },

    _syncToWidget: function() {
        this._syncing = true;
        this.value(this.element.val());
        this.trigger("change");
        this._syncing = false;
    },

    _wrapperMousedown: function() {
        if (!accessible.isInAccessibleMode() || !this.options.accessibleMode) {
            kendo.ui.MultiSelect.fn._wrapperMousedown.apply(this, arguments);
        }
    },

    _setNativeSize() {
        this.element.attr("size", Math.max(4, Math.min(10, this.dataSource.total())));
    }
}
